import { DefaultRefreshHandler } from '/opt/buildhome/repo/node_modules/@sidebase/nuxt-auth/dist/runtime/utils/refreshHandler'
export const _refreshHandler = new DefaultRefreshHandler({"enablePeriodically":false,"enableOnWindowFocus":true})